import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const ResetTimeIconSvg = () => {
    return (
        <SvgIcon
            sx={{
                width: '16px',
                height: '16px',
            }}
        >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15.5C6.08333 15.5 4.41319 14.8646 2.98958 13.5938C1.56597 12.3229 0.75 10.7361 0.541667 8.83333H2.25C2.44444 10.2778 3.08681 11.4722 4.17708 12.4167C5.26736 13.3611 6.54167 13.8333 8 13.8333C9.625 13.8333 11.0035 13.2674 12.1354 12.1354C13.2674 11.0035 13.8333 9.625 13.8333 8C13.8333 6.375 13.2674 4.99653 12.1354 3.86458C11.0035 2.73264 9.625 2.16667 8 2.16667C7.04167 2.16667 6.14583 2.38889 5.3125 2.83333C4.47917 3.27778 3.77778 3.88889 3.20833 4.66667H5.5V6.33333H0.5V1.33333H2.16667V3.29167C2.875 2.40278 3.73958 1.71528 4.76042 1.22917C5.78125 0.743056 6.86111 0.5 8 0.5C9.04167 0.5 10.0174 0.697917 10.9271 1.09375C11.8368 1.48958 12.6285 2.02431 13.3021 2.69792C13.9757 3.37153 14.5104 4.16319 14.9062 5.07292C15.3021 5.98264 15.5 6.95833 15.5 8C15.5 9.04167 15.3021 10.0174 14.9062 10.9271C14.5104 11.8368 13.9757 12.6285 13.3021 13.3021C12.6285 13.9757 11.8368 14.5104 10.9271 14.9062C10.0174 15.3021 9.04167 15.5 8 15.5ZM10.3333 11.5L7.16667 8.33333V3.83333H8.83333V7.66667L11.5 10.3333L10.3333 11.5Z"
                    fill="white"/>
            </svg>
        </SvgIcon>
    );
};

export default ResetTimeIconSvg;